"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeDateFilterSelectionHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sdk_model_1 = require("@gooddata/sdk-model");
var toNumber_1 = tslib_1.__importDefault(require("lodash/toNumber"));
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var common_1 = require("../common");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
var general_1 = require("../../../events/general");
function changeDateFilterSelectionHandler(ctx, cmd) {
    var isAllTime, canApply, affectedFilter;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isAllTime = cmd.payload.type === "relative" &&
                    cmd.payload.granularity === "GDC.time.date" &&
                    cmd.payload.from === undefined &&
                    cmd.payload.to === undefined;
                return [4 /*yield*/, effects_1.call(common_1.canApplyDateFilter, dateFilterSelectionToDateFilter(cmd.payload))];
            case 1:
                canApply = _a.sent();
                if (!canApply) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Cannot apply a date filter that is invalid by the current dateFilterConfig.");
                }
                return [4 /*yield*/, effects_1.put(filterContext_1.filterContextActions.upsertDateFilter(isAllTime
                        ? { type: "allTime" }
                        : {
                            type: cmd.payload.type,
                            granularity: cmd.payload.granularity,
                            from: cmd.payload.from,
                            to: cmd.payload.to,
                        }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextDateFilter)];
            case 3:
                affectedFilter = _a.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.dateFilterChanged(ctx, affectedFilter, cmd.payload.dateFilterOptionLocalId, cmd.correlationId))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.changeDateFilterSelectionHandler = changeDateFilterSelectionHandler;
function dateFilterSelectionToDateFilter(dateFilterSelection) {
    if (dateFilterSelection.type === "absolute" && dateFilterSelection.from && dateFilterSelection.to) {
        return sdk_model_1.newAbsoluteDashboardDateFilter(dateFilterSelection.from.toString(), dateFilterSelection.to.toString());
    }
    else if (dateFilterSelection.type === "relative" &&
        dateFilterSelection.granularity === "GDC.time.date" &&
        dateFilterSelection.from === undefined &&
        dateFilterSelection.to === undefined) {
        return sdk_model_1.newAllTimeDashboardDateFilter();
    }
    else {
        return sdk_model_1.newRelativeDashboardDateFilter(dateFilterSelection.granularity, toNumber_1.default(dateFilterSelection.from), toNumber_1.default(dateFilterSelection.to));
    }
}
//# sourceMappingURL=changeDateFilterSelectionHandler.js.map